import { INotification, INotificationQuery } from 'src/types';
import { http } from 'src/utils';
import BaseService from './base.service';

export default class NotificationService extends BaseService<INotification, INotificationQuery> {
  constructor() {
    super('/api/notification');
  }

  public async seen(id: string) {
    const { data } = await http.put<boolean>(`${this.url}/seen/${id}`);
    return data;
  }
}
